import React from 'react';
import { useHistory } from 'react-router-dom';

const HeroCarouselSlideFour = () => {
  const history = useHistory();
  return (
    // <div className='text__and-card-1'>
    <div className='carousel__slide-box carousel__box-two carousel__box-four'>
      <div className='slide__4-text--box'>
        <p className='slide__4-text--1'>
          African Shipping Outlook 2025 is here
        </p>
        <p className='slide__4-text--2'>
          The data behind Africa’s export economy.{' '}
        </p>
        <p className='card__1--text--3 slide__4-text--3'>By Topship </p>
        <button
          className='carousel__slide-4--cta'
          onClick={() => history.push('/report')}
        >
          View Report Summary
        </button>
      </div>
    </div>
  );
};

export default HeroCarouselSlideFour;
